<div class="title">
  <mat-icon>event</mat-icon>
  Date Range
</div>
<div class="description">SELECT THE MONTHS TO FILTER BY</div>

<div class="options">
  <form #dateForm="ngForm" style="margin: 0px">
    <div class="label-date">
      <dialog-label> From: </dialog-label>
      <framework-dialog-date-picker
        placeholder="From Date"
        [(ngModel)]="from"
        name="from"
        timeOfDay="start"
        [max]="to ?? undefined"
        (ngModelChange)="fromChange($event)"
        class="lightMode"
        required
      ></framework-dialog-date-picker>
    </div>
    <div class="label-date">
      <dialog-label> To:</dialog-label>
      <framework-dialog-date-picker
        placeholder="To Date"
        [(ngModel)]="to"
        name="to"
        timeOfDay="end"
        (ngModelChange)="toChange($event)"
        [min]="from ?? undefined"
        class="lightMode"
        required
      ></framework-dialog-date-picker>
    </div>
  </form>
</div>

<div class="actions">
  <button styles-button (click)="closeFilterPanel()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
